"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTHENTICATED_LOG_ASKEM_EVENT = void 0;
const gql_1 = require("../__generated__/gql");
exports.AUTHENTICATED_LOG_ASKEM_EVENT = (0, gql_1.gql)(/* GraphQL */ `
    mutation AuthenticatedLogAskemEvent($input: LogAskemEventInput!) {
        authenticatedLogAskemEvent(input: $input) {
            wasSuccessful
            uid
        }
    }
`);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aGVudGljYXRlZExvZ0Fza2VtRXZlbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZ3JhcGhxbC9hdXRoZW50aWNhdGVkTG9nQXNrZW1FdmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw4Q0FBMkM7QUFFOUIsUUFBQSw2QkFBNkIsR0FBRyxJQUFBLFNBQUcsRUFBQyxhQUFhLENBQUM7Ozs7Ozs7Q0FPOUQsQ0FBQyxDQUFDIn0=